module.exports = __webpack_public_path__ + "img/krabi_th.413db057.png";